import { LOCALE_ID, NgModule, APP_INITIALIZER, PLATFORM_ID, Optional } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MaterialModule } from './MaterialModule';
import { FooterComponent } from './components/footer/footer.component';

import { MenuModule } from './components/menu/menu.module';

import { HeaderComponent } from './components/header/header.component';
import { DecimalPipe, isPlatformBrowser, registerLocaleData } from '@angular/common';
import {
    AbstractSecurityStorage,
    AuthInterceptor,
    DefaultLocalStorageService,
} from 'angular-auth-oidc-client';
import { UserDataComponent } from './components/user-data/user-data.component';
import localeIt from '@angular/common/locales/it';

registerLocaleData(localeIt);
import { CookieModule, CookieService } from 'ngx-cookie';
import { PanelsModule } from './components/panels/panels.module';
import { initializeAppWithPageLoader, InitService } from 'src/_services';
import { ComparatoreAuthModule } from 'src/_services/auth/comparatore-auth.module';
import { CRAWLER_AGENTS, REQUEST, VIEWER } from 'src/express/tokens';

@NgModule({
    declarations: [
        AppComponent,
        FooterComponent,
        HeaderComponent,
        UserDataComponent,
    ],
    bootstrap: [AppComponent],
    imports: [BrowserModule,
        AppRoutingModule,
        // MatDialogModule,
        MaterialModule,
        CookieModule.withOptions(),
        PanelsModule,
        MenuModule,
        // AuthModule.forRoot({
        //     config: {
        //         authority: BrowserConfig.openiddictsettings.authority,
        //         redirectUrl: BrowserConfig.openiddictsettings.redirectUrl,
        //         postLogoutRedirectUri: BrowserConfig.openiddictsettings.postLogoutRedirectUri,
        //         clientId: BrowserConfig.openiddictsettings.clientId,
        //         //scope: 'openid roles profile',
        //         scope: BrowserConfig.openiddictsettings.scope,
        //         responseType: BrowserConfig.openiddictsettings.responseType,
        //         silentRenew: BrowserConfig.openiddictsettings.silentRenew,
        //         renewTimeBeforeTokenExpiresInSeconds: BrowserConfig.openiddictsettings.renewTimeBeforeTokenExpiresInSeconds,
        //         useRefreshToken: BrowserConfig.openiddictsettings.useRefreshToken,
        //         ignoreNonceAfterRefresh: BrowserConfig.openiddictsettings.ignoreNonceAfterRefresh,
        //         // authority: "https://preprod-polizzevita.fidainformatica.it/login",
        //         // redirectUrl: "https://preprod-mfplus.fidaworkstation.it/comparatore",
        //         // postLogoutRedirectUri: "https://preprod-mfplus.fidaworkstation.it/comparatore",
        //         // clientId: window["openiddictsettings"]["clientId"],
        //         // //scope: 'openid roles profile',
        //         // scope: window["openiddictsettings"]["scope"],
        //         // responseType: window["openiddictsettings"]["responseType"],
        //         // silentRenew: window["openiddictsettings"]["silentRenew"],
        //         // renewTimeBeforeTokenExpiresInSeconds: window["openiddictsettings"]["renewTimeBeforeTokenExpiresInSeconds"],
        //         // useRefreshToken: window["openiddictsettings"]["useRefreshToken"],
        //         // ignoreNonceAfterRefresh: window["openiddictsettings"]["ignoreNonceAfterRefresh"],
        //         //historyCleanupOff: false,
        //         //issValidationOff: true,
        //         logLevel: LogLevel.Debug,
        //         //use the built in interceptor to add the accesstokens to your request
        //         secureRoutes: [
        //             `${BrowserConfig.apiBaseDomain}/comparatore`,
        //             `${BrowserConfig.apiBaseDomain}/comparatore/utenti/preferiti`
        //         ],
        //     },
        // }),
        // AuthModule.forRoot({
        //     loader: {
        //         provide: StsConfigLoader,
        //         useFactory: authFactory1,
        //         deps: [],
        //     }
        // })
        ComparatoreAuthModule.forRoot()], providers: [
            {
                provide:VIEWER,
                useFactory : viewerFactory,
                deps: [PLATFORM_ID, [new Optional(), REQUEST]]

            },
            {
                provide: APP_INITIALIZER,
                useFactory: initializeAppWithPageLoader,
                deps: [InitService],
                multi: true
            },
            DecimalPipe,
            { provide: LOCALE_ID, useValue: 'it' },
            // { provide: LocationStrategy, useClass: HashLocationStrategy },
            CookieService,
            //{provide : COOKIE_OPTIONS, useValue}
            { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
            {
                provide: AbstractSecurityStorage,
                useClass: DefaultLocalStorageService,
            },
            provideClientHydration() // CookieManagerService-> Attenzione 4kb max size per cookie !!!
            ,
            provideHttpClient(withInterceptorsFromDi())
        ]
})
export class AppModule { }
export function viewerFactory(platformId, req: Request): string {
    if (isPlatformBrowser(platformId)) {
      return 'user';
    }
    const userAgent = (req.headers['user-agent'] || '').toLowerCase();
    const isCrawler = CRAWLER_AGENTS.some(crawlerAgent => userAgent.indexOf(crawlerAgent) !== -1);
    return isCrawler ? 'bot' : 'user';
  }

